module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mainpage"
    }
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "headerBlank"
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2239a1dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2239a1dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainPage.vue
// module id = 685
// module chunks = 0